var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { attrs: { id: "corra" } },
    [
      _vm.routeGroup === "auth"
        ? _c("div", { staticClass: "corra-bg" })
        : _vm._e(),
      _c(
        "v-alert",
        {
          staticClass: "global-error mb-0",
          attrs: { type: "error", dismissible: "", tile: "" },
          model: {
            value: _vm.showError,
            callback: function ($$v) {
              _vm.showError = $$v
            },
            expression: "showError",
          },
        },
        [_vm._v(_vm._s(_vm.appError))]
      ),
      _vm.isLoggedIn
        ? _c(
            "v-app-bar",
            {
              attrs: {
                app: "",
                "clipped-left": "",
                color: "primary",
                dark: "",
                height: "48",
              },
            },
            [
              _c("v-toolbar-title", [
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$router.push("/")
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.logoImage, height: "24", alt: "Corra" },
                    }),
                  ]
                ),
              ]),
              _c("router-view", { attrs: { name: "menu" } }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-main",
        { class: { primary: _vm.isPrimaryRoute } },
        [
          _c("router-view"),
          _c(
            "v-overlay",
            { attrs: { value: _vm.isLoading } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { timeout: 5000, color: _vm.appMessage.color },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function (ref) {
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function ($event) {
                            _vm.showMessage = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.showMessage,
            callback: function ($$v) {
              _vm.showMessage = $$v
            },
            expression: "showMessage",
          },
        },
        [_vm._v(" " + _vm._s(_vm.appMessage.text) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }